import { apiBaseUrl } from "./config";
import type { SurfaceRecord } from "./types";

export async function fetchSurfaceByToken(
  token: string,
  signal?: AbortSignal,
): Promise<SurfaceRecord> {
  const res = await fetch(
    `${apiBaseUrl}/public/verify/${encodeURIComponent(token)}`,
    { signal, headers: { accept: "application/json" } },
  );
  if (!res.ok) throw new Error(`Verification lookup failed (${res.status})`);
  return (await res.json()) as SurfaceRecord;
}
